module.exports = __webpack_public_path__ + "img/DSC_2748-xl.7a219cb6.png";